export default __webpack_public_path__ + "static/media/fr-cp.2e82c215.svg";